import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const kuponTipi = z.enum(['TEKIL', 'COK_KULLANIMLIK', 'ILK_KULLANICI', 'PARTNER_OZEL']);
export const kuponIndirimTipi = z.enum(['YUZDE', 'SABIT']);
export const kupon = z.object({
    id: z.string(),
    kod: z.string(),
    tip: kuponTipi,
    indirimTipi: kuponIndirimTipi,
    indirimDegeri: z.string(),
    maxIndirimTutar: z.string().nullable().optional(),
    minKiralamaTutar: z.string().nullable().optional(),
    paraBirimi: paraBirimi.nullable().optional(),
    toplamLimit: z.number().int().nullable().optional(),
    kullanimSayisi: z.number().int(),
    musteriBasinaLimit: z.number().int(),
    gecerliBaslangic: z.string().datetime(),
    gecerliBitis: z.string().datetime(),
    sadeceNoktalar: z.array(z.string()),
    sadecePartnerler: z.array(z.string()),
    aciklama: z.string(),
    aktif: z.boolean(),
    olusturmaTarihi: z.string().datetime(),
});
const kuponAlanlari = z.object({
    kod: z
        .string()
        .trim()
        .min(3)
        .max(40)
        .regex(/^[A-Z0-9_-]+$/, 'Sadece A-Z, 0-9, _, -'),
    tip: kuponTipi.default('COK_KULLANIMLIK'),
    indirimTipi: kuponIndirimTipi.default('YUZDE'),
    indirimDegeri: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Geçerli değer girin'),
    maxIndirimTutar: z
        .string()
        .regex(/^\d+(\.\d{1,2})?$/)
        .nullable()
        .optional(),
    minKiralamaTutar: z
        .string()
        .regex(/^\d+(\.\d{1,2})?$/)
        .nullable()
        .optional(),
    paraBirimi: paraBirimi.nullable().optional(),
    toplamLimit: z.number().int().min(1).nullable().optional(),
    musteriBasinaLimit: z.number().int().min(1).default(1),
    gecerliBaslangic: z.string().datetime(),
    gecerliBitis: z.string().datetime(),
    sadeceNoktalar: z.array(z.string()).default([]),
    sadecePartnerler: z.array(z.string()).default([]),
    aciklama: z.string().trim().min(3).max(200),
    aktif: z.boolean().default(true),
});
export const kuponOlusturIstegi = kuponAlanlari.refine((d) => new Date(d.gecerliBitis) > new Date(d.gecerliBaslangic), { message: 'Bitiş tarihi başlangıçtan sonra olmalı', path: ['gecerliBitis'] });
export const kuponGuncelleIstegi = kuponAlanlari.partial();
export const kuponSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(50),
    arama: z.string().optional(),
    aktif: z.coerce.boolean().optional(),
    tip: kuponTipi.optional(),
});
export const kuponKullanimi = z.object({
    id: z.string(),
    kuponId: z.string(),
    musteriId: z.string().nullable().optional(),
    musteriAdSoyad: z.string().nullable().optional(),
    misafirTelefon: z.string().nullable().optional(),
    kiralamaId: z.string(),
    kiralamaKod: z.string().nullable().optional(),
    uygulananIndirim: z.string(),
    kullanimTarihi: z.string().datetime(),
});
//# sourceMappingURL=kupon.js.map